import { z } from 'zod'

export enum MESSAGE_SENT_SOURCE {
  CHAT = 'chat',
  FEED_CHAT = 'feed-chat',
  FEED_TASK = 'feed-task',
}

export const messageSentSchema = z.object({
  source: z.enum([MESSAGE_SENT_SOURCE.CHAT, MESSAGE_SENT_SOURCE.FEED_CHAT, MESSAGE_SENT_SOURCE.FEED_TASK]),
  masterTaskId: z.string().optional(),
  programUuid: z.string(),
  hasAttachments: z.boolean(),
  attachmentsTypesList: z.array(z.enum(['academy_video', 'image', 'video', 'file'])),
})
